import { useState, useEffect, useRef } from 'react';
import './styles.css';

export default function Select({
  availableGames = [],
  onSelectChange,
  row,
  selectedValue,
  disabled
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  const selectRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsExpanded(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  
  const handleSelectToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const handleSelectChange = (selectTransaction) => {
    onSelectChange(selectTransaction, row);
    setIsExpanded(false);
  };

  const gameTypeLabels = {
    ACC: 'Classification',
    NOR: 'Normal Balance',
    BE: 'Double Entry',
    PR: 'The principles',
  };

  const selectedGame = selectedValue 
    ? selectedValue
    : row.gameId
      ? gameTypeLabels[availableGames.find(game => game.id === row.gameId)?.type] || 'Select game'
      : 'Select game';

  return (
    <div className={`games-select-wrapper ${disabled ? 'disabled' : ''}`} ref={selectRef}>
      <div className="games-select-header" onClick={(onSelectChange && !disabled) ? handleSelectToggle : null}>
        {selectedGame}
        {
          onSelectChange && <span className="games-select-icon"></span>
        }
      </div>
      <div className={`games-select-body ${isExpanded ? 'active' : ''}`}>
        <ul>
          {availableGames?.map((game, index) => (
            <li 
              key={index}
              onClick={() => handleSelectChange(game)}
            >
              {gameTypeLabels[game.type] || game.type}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
